import { useQuery } from '@tanstack/react-query';
import { getStudyProcedures } from 'api/study';
import { Procedure } from 'interfaces/procedure';

const PAGE_SIZE = 50;

export const getCompleteStudyProcedures = async (studyId: string): Promise<Procedure[]> => {
  const procedures: Procedure[] = [];
  let page = 1;
  let pageProcedures: Procedure[];

  do {
    pageProcedures = await getStudyProcedures({ studyId, page, pageSize: PAGE_SIZE });
    procedures.push(...pageProcedures);
    page += 1;
  } while (pageProcedures.length === PAGE_SIZE);

  return procedures;
};

export const useCompleteStudyProcedures = (studyId: string, enabled: boolean = true) => {
  const query = useQuery({
    queryKey: ['procedures', studyId, 'complete'],
    queryFn: () => getCompleteStudyProcedures(studyId),
    enabled: enabled && Boolean(studyId),
    // Review links use this case/slide list. Refresh it without clearing the current list.
    refetchInterval: 60000,
  });

  return {
    ...query,
    procedures: query.data || [],
  };
};
